export const structureItems = [
  {
    id: 'musculacao',
    title: 'Área de Musculação',
    description: 'Equipamentos e pesos livres para treino completo',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/edfbf516-fa9d-486d-87f9-9f52c9c1de2b_topgym-estrutura1.webp?v=52881ca8ffdce80104f87fedcc2d51ca',
  },
  {
    id: 'pesos-livres',
    title: 'Pesos Livres',
    description: 'Halteres, kettlebells, anilhas e barras',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/ee786c09-ff54-4d2a-9a93-cccdb3cd4987_topgym-estrutura11.webp?v=629d90a6718bb4958178ff0f5098b087',
  },
  {
    id: 'cross-training',
    title: 'Espaço Cross Training',
    description: 'Área para treino funcional e circuito',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/81830c33-6364-45d5-8319-8f946be0bb8d_topgym-estrutura5.webp?v=704f0c7b91a98facdcd3383848fdb2b4',
  },
  {
    id: 'muay-thai',
    title: 'Área de Muay Thai e jiu jitsu',
    description: 'Ringue e tatames para treino de lutas',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/44aa2829-f44b-4855-911e-0ed8b1c49b05_topgym-estrutura10.webp?v=6b484002b02a1a49514fffadcd1143da',
  },
  {
    id: 'aulas',
    title: 'Espaço para Aulas',
    description: 'Sala para aulas coletivas e funcional',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/671346b4-3f6e-489e-94c7-46100fe53ecf_topgym-estrutura6.webp?v=ff8c141282a613e5000c14a5179e5ed4',
  },
  {
    id: 'recepcao',
    title: 'Recepção',
    description: 'Atendimento personalizado e acolhedor',
    image: 'https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/be5de31e-b677-4f80-98b1-3701624ac1d3_topgym-estrutura18.webp?v=23decfde6649c1060573b1b3156f368f',
  },
];